<section>
  <div class="Flexbox Flexbox-direction-rows Flexbox__just-space-around">
    <div class="results-pane-subheader">{{'Specimens' | stringTranslate}}</div>
    <gen-add-sample (updatedOrder)="emitUpdate($event)" *ngIf="showaddbutton" [sampleType]="sampletype"></gen-add-sample>
  </div>
  <gen-sample-list [primaryid]="primaryid"
                   [callback]="callback"
                   [samples]="samples"
                   [overrides]="overrides"
                   [specimensConfig]="samplesConfig"
                   [markAsPrimaryEnabled]="markAsPrimaryEnabled"
                   [proceedToAnaliseStarted]="proceedToAnaliseStarted"
                   [allowedit]=" allowedit"
                   [editMode]="editMode"
                   [disabledForced]="disabledForced"
                   (updateSamples)="emitUpdate({specimen:$event,primaryTumor:primaryid})"
  ></gen-sample-list>
</section>
